import Angular from "angular";
import Loader from "angular-ecmascript/module-loader";
import {Service} from "angular-ecmascript/module-helpers";
import Settings from "../providers/settings.provider";
import User from "../model/user.model";

export var Name = 'authService';

export class AuthService extends Service {
    static $name = Name;
    static $inject = ['$q', '$http', 'settings'];

    create() {
        // NOOP.
    }

    login(host, username, password) {
        let loginRequest = {
            login: username,
            password: password
        };

        return this.$http.post(this.settings.httpUrlWithHost(host, 'app') + "/login", loginRequest)
            .then((response)=> {
                return new User(response.data);
            });
    }
}

let AuthServiceModule = Angular.module('auth-service', [Settings.name]);

new Loader(AuthServiceModule)
    .load(AuthService);

export default AuthServiceModule;



// WEBPACK FOOTER //
// ./src/modules/main/services/auth.service.js